<template>
  <v-cotainer fluid grid-list-md fill-height >
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
            <v-toolbar-title class="text-xs-center">
              Letter Head
            </v-toolbar-title>
            <v-spacer></v-spacer>   
            <v-btn outlined @click="letterHeadDialog = true">
              <v-icon left color="teal">add</v-icon> New Letter Head
            </v-btn>
        </v-toolbar>

        <v-data-table
          :headers="letterHeadHeader"
          :items="letterHeadsByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-icon :disabled="getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'" @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
            </td>
            
            <td>
              <b>{{props.item['letterHeadNumber']}}</b>
            </td>
            <td>
              <b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b>
            </td>
            
            <td>
              <b>{{getCustomerName(props.item.buyerId)}}</b>
            </td>

            <td>
              <v-btn icon class="mx-0" v-if="props.item['status'] == 'IN PROGRESS'" @click="editLetterHead(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteLetterHead(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="printLetterHead(props.item)">
                <v-icon color="blue">print</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    
    <!-- Start Product Transfer Dialog -->
    <v-dialog v-model="letterHeadDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline" v-if="isEdit">Edit LetterHead</span>
          <span class="headline" v-else>Create LetterHead</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
            <v-flex xs12 sm12 md12>
           <v-switch
              :disabled="isEdit"
              v-model="isBuyer"
              :label="`${isBuyer ? 'Customer Letter Head' : 'Supplier Letter Head'}`"
            ></v-switch>
        </v-flex>
         <v-flex xs12 sm4 md4>
            <v-select
              dense
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-select>
          </v-flex>

        <v-flex xs12 sm4 md4>
           <v-select 
                v-bind:items="isBuyer ? buyersByBrand : sellersByBrand"
                v-model="selectedBuyer" 
                :label="isBuyer ? 'Select or add Buyer' : 'Select or add Seller'"
                autocomplete
                :disabled="isEdit"
                item-text="name"
                return-object
                @keyup.native.enter="addCustomer"
            >   
           </v-select>
        </v-flex>
            
        <v-flex xs12 sm2 md2>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerLetterHead"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="date"
              label="Letter Head Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="date" @input="datepickerLetterHead = false"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-text-field
            v-model="letterHeadNumber"
            prefix="#"
            label="Letter Head Number"
            placeholder="Enter Letter Head Number"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-textarea 
               background-color="grey darken-1"
               color="black"
               label="Content" 
               box 
               v-model="letterHeadContent" >
            </v-textarea>
        </v-flex>  

        </v-layout>
        </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="letterHeadDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled=" !selectedBuyer || !selectedFirm"
                @click="addLetterHead()"
                flat
              >{{isEdit ? 'Save' : 'Create' }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="invoiceLetterHead" width="800" v-if="selectedLetterHead && selectedLetterHead['.key']">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>Letter Head Content 
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title>  
            {{selectedLetterHead['letterHeadContent']}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="invoiceLetterHead = false">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      productsToLetterHead : [],
      items:[],
      isEdit:false,
      letterHeadDialog: false,
      isBuyer : true,
      invoiceLetterHead : false,
      historyStep: 1,
      selectedLetterHead : null,
      selectedBuyer : null,
      selectedFirm : null,
      date:  new Date().toISOString().substr(0, 10),
      datepickerLetterHead: false,
      statusFilter : 'ALL',
      letterHeadNumber: null,
      letterHeadHistory : false,
      letterHeadContent : null,
      modalMode:null,
      letterHeadHeader: [
        { text: "View", value: "view" },
        // { text: "History", value: "history" },
        // { text: "Orignal LetterHead", value: "originalLetterHead" },
        { text: "Letter Head Number", value: "letterHeadNumber" },
        { text: "Letter Head Date", value: "date", sortable: true },
        // { text: "Invoice No", value: "invoiceId" },
        // { text: "Invoice Date", value: "date", sortable: true},
        { text: "Customer Name", value: "name" }, 
        // { text: "Total Amount", value: "name" }, 
        // { text: "Status", value: "edit" },
        { text: "Print", value: "edit" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "edit" },
      ],
      productInvoiceHeader: [
        { text: "Name", value: "Name" },
        { text: "Quantity", value: "Taxable" },
        { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" },
        { text: "Total", value: "total" },
      ]
    };
  },
  created() {
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("letterHeads", this.$root.$firebaseRefs.letterHeads.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand",'finYear']),
    ...mapGlobalGetters({ units: "productUnit" }),
    
    letterHeadsByBrand(){
      return this.letterHeads.filter(
        item => {
          return (item["brand"] === this.selectedBrand 
          && (this.statusFilter != 'ALL' ? item.status == this.statusFilter : true))
        }
      );
    },
    buyersByBrand(){
      return this.buyers
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
    },
    sellersByBrand(){
      return this.sellers
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
    },
    firmsByBrand() {
      return this.firms
        .filter(item => item["brand"] === this.selectedBrand)
        .map(item => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    
  },
  methods: {
    openProd(item){
      this.selectedLetterHead =item; 
      this.invoiceLetterHead = true;
    },
    getFirmName(e){
      let firm;
        if (this.firms && this.selectedBrand) {
          firm =this.firms.filter(item => item['.key'] === e)[0]
        }
      if(firm)
        return firm.name
    },
    getCustomerName(id) {
      let buyer = this.buyerById[id];
      let seller = this.sellerById[id];
      if(!buyer && !seller) {
        return 'DELETED CUSTOMER'
      }
      return buyer ? buyer.name : seller.name;
    },
    addCustomer:function(e){
      let obj = {
        name :  e.target.value,
        brand : this.selectedBrand
      }
      if(this.selectedFirm) {
        obj['state'] = this.selectedFirm
      }

      if(this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    createInvoice(){
      let key = this.selectedLetterHead['.key'];
      delete this.selectedLetterHead['.key'];
      this.$root.$firebaseRefs.letterHeads.child(key).set(this.selectedLetterHead).then((snap)=>{
        this.selectedLetterHead = null;
        this.$router.push({path: `/letterHead-to-invoice/${key}` })
        this.invoiceLetterHead = false;
      });
    },
    cancelLetterHead(letterHead){
        let key = letterHead['.key'];
        delete letterHead['.key'];
        letterHead['status'] = 'CANCELLED'
        this.$root.$firebaseRefs.letterHeads.child(key).set(letterHead).then((snap)=>{
        });
    },
    editLetterHead(letterHead){
      this.productsToLetterHead = [];
      this.letterHeadDialog = true;
      this.isEdit = true;
      this.firm = letterHead.firm;
      this.date = new Date(letterHead.date).toISOString().substr(0, 10),
      this.letterHeadNumber = letterHead.letterHeadNumber,
      this.letterHeadContent = letterHead.letterHeadContent
      this.selectedLetterHead = letterHead;
      this.isBuyer = letterHead.isBuyer;
      if(letterHead.isBuyer) {
        this.selectedBuyer = this.buyerById[letterHead.buyerId]
      } else {
        this.selectedBuyer = this.sellerById[letterHead.buyerId]
      }
    },
    addLetterHead(){
      let letterHeadObj = {
        buyerId : this.selectedBuyer['.key'],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        letterHeadNumber: this.letterHeadNumber,
        letterHeadContent: this.letterHeadContent,
        items: this.items,
      }
      if(this.isEdit ) {
        letterHeadObj['status'] = this.selectedLetterHead['status']; 
        letterHeadObj['buyerId'] = this.selectedLetterHead['buyerId']; 
        this.$root.$firebaseRefs.letterHeads.child(this.selectedLetterHead['.key']).set(letterHeadObj).then((snap)=>{
            this.isEdit = false;
        });
      } else {
        letterHeadObj['status'] = 'IN PROGRESS';
        this.$root.$firebaseRefs.letterHeads.push(letterHeadObj);
      }
      this.letterHeadDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
    },
    deleteLetterHead(letterHead) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.letterHeads.child(letterHead[".key"]).remove();
      }
    }
  }
};
</script>
<style>
.status-filter.v-select .v-select__selections, .status-filter.v-icon {
    color: #fff !important;
}
.status-filter.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: #fff;
}
</style>
<style scoped>
.invoice-stepper {
  border: 1px solid #01579b;
  border-radius: 4px;
  background: #fafafa;
}
</style>




// WEBPACK FOOTER //
// src/components/Settings/LetterHead/LetterHead.vue